__turbopack_context__.v({
  "noResultsContainer": "styles-module__HBOvhq__noResultsContainer",
  "noResultsFound": "styles-module__HBOvhq__noResultsFound",
});
